/** @format */
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { stringify } from 'qs';

import {
    convertKeyNames,
    toCamelCase,
    toSnakeCase,
} from '@toucan/common/helpers/change-case';

function requestFulfilled(request: AxiosRequestConfig): AxiosRequestConfig {
    // if we have no data then we can just return the original request
    if (!request.data) {
        return request;
    }

    // convert our data keys to snake case
    const data = convertKeyNames(request.data, toSnakeCase);

    // if we need form data instead of json then we need to stringify our data
    if (
        request.headers?.['Content-Type'] ===
        'application/x-www-form-urlencoded'
    ) {
        request.data = stringify(data, {
            encodeValuesOnly: true,
            arrayFormat: 'repeat',
        });
        return request;
    }

    // add our converted json data to the request and return it
    request.data = data;
    return request;
}

function responseFulfilled(response: AxiosResponse): AxiosResponse {
    response.data = convertKeyNames(response.data, toCamelCase);
    return response;
}

function responseRejected(error: any) {
    if (!axios.isCancel(error) && error?.response?.data) {
        error.response.data = convertKeyNames(error.response.data, toCamelCase);
    }
    return Promise.reject(error);
}

export const changeCaseInterceptor = {
    requestFulfilled,
    responseFulfilled,
    responseRejected,
};
